import { useEffect } from 'react';

const useDocumentClick = (handleClick: () => void) => {
  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
};

export default useDocumentClick;
